import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import { Navigate } from 'react-router-dom';
import './custom.css';
import Login from './components/LoginPage';

export default class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: false,
        };
    }

    componentDidMount() {
        const isUserAuthenticated = sessionStorage.getItem('isAuthenticated');
        this.setState({ isAuthenticated: isUserAuthenticated === 'true' });
    }

    authenticateUser = (username, password) => {
        // Here you would have your hardcoded users and their passwords
        const users = { 'admin': 'admin', 'yantinIoT': 'yantinAdmin' };
        const isAuthenticated = users[username] === password;

        sessionStorage.setItem('isAuthenticated', isAuthenticated);
        this.setState({ isAuthenticated });
    };

    render() {
        return (
            <div>
                {!this.state.isAuthenticated ? (
                    <Login authenticate={this.authenticateUser} />
                ) : (
                    <Layout>
                        <Routes>
                            {AppRoutes.map((route, index) => {
                                const { element, ...rest } = route;
                                return <Route key={index} {...rest} element={element} />;
                            })}
                        </Routes>
                    </Layout>
                )}
            </div>


        );
    }
}
